import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useQuery } from '../hooks/useQuery';
import { useForm, Controller } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel, {
  getFormControlLabelUtilityClasses,
} from '@mui/material/FormControlLabel';
import { FormControl } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useAuth } from '../hooks/useAuth';
import { useSnackbar } from '../hooks/useSnackbar';
import SaveIcon from '@mui/icons-material/Save';
import CustomizedDialogs from '../components/ModalAlert';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import FormLabel from '@mui/material/FormLabel';
import Moment from 'moment';
import { decryptData, encryptData } from '../utils';
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';

const CODIGOS_NATUREZA_PF = ['10002', '13002'];
const CODIGOS_NATUREZA_PJ = [
  '15001',
  '15002',
  '15003',
  '15008',
  '15014',
  '15019',
  '15020',
  '15026',
  '15029',
  '15032',
  '15042',
  '15043',
  '15044',
  '15045',
  '15046',
  '15049',
  '15099',
];

export const Step1Cadastro = ({
  activeStep,
  setActiveStep,
  fornecedor,
  setFornecedor,
}) => {
  const [radioValue, setRadioValue] = React.useState('PF');
  const [contratacaoTeto, setContratacaoTeto] = React.useState(null);
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const {
    cadastroStep1,
    showCadastroFornecedor,
    getCustomer,
    getCompany,
    getComboTipoServico,
    getComboNaturezaRendimento,
    obterFornecedorPorCnpj,
    verificarFornecedor,
  } = useQuery();
  const { user } = useAuth();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);
  const [company, setCompany] = React.useState();
  const [customer, setCustomer] = React.useState();
  const [isRascunho, setIsRascunho] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [tipoServico, setTipoServico] = React.useState([]);
  const [naturezaRendimento, setNaturezaRendimento] = React.useState([]);
  const [show, setShow] = React.useState(false);
  const [hideFields, setHideFields] = React.useState(false);
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const [selectedTipoServico, setSelectedTipoServico] = React.useState(null);
  const [selectedNaturezaRendimento, setSelectedNaturezaRendimento] =
    React.useState(null);
  const snackbar = useSnackbar();
  const [checkStep1, setCheckStep1] = React.useState(false);

  const naturezaRendimentoFiltrado = React.useMemo(() => {
    if (radioValue === 'PF') {
      return naturezaRendimento.filter((item) =>
        CODIGOS_NATUREZA_PF.includes(item['cod-natur-rendto']),
      );
    }
    return naturezaRendimento.filter((item) =>
      CODIGOS_NATUREZA_PJ.includes(item['cod-natur-rendto']),
    );
  }, [naturezaRendimento, radioValue]);

  React.useEffect(() => {
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }
      preencherFormulario(decryptData(searchParams.get('fornecedor_id')));
    }
    comboNaturezaRendimento();
    comboTipoServico();
  }, []);

  const comboTipoServico = async () => {
    let result = await getComboTipoServico();
    if (result && result.data && result.data.data) {
      setTipoServico(result.data.data);
    }
  };

  const comboNaturezaRendimento = async () => {
    let result = await getComboNaturezaRendimento();
    if (result && result.data && result.data.data) {
      setNaturezaRendimento(result.data.data);
    }
  };

  const onChangeDocument = async (e) => {
    if (!e.target.value) return;
    if (radioValue == 'PF') {
      if (e.target.value.replace(/\D/g, '').length == 11) {
        if (
          searchParams.get('fornecedor_id') &&
          !decryptData(searchParams.get('fornecedor_id')) &&
          !fornecedor
        ) {
          const verifyExistDB = await verificarFornecedor(
            e.target.value.replace(/\D/g, ''),
          );

          if (
            verifyExistDB &&
            verifyExistDB.data &&
            verifyExistDB.data.message == 'sucesso'
          ) {
            snackbar.showSnackbar(
              'Já existe uma solicitação em aberto para o CNPJ informado. Favor aguardar a análise.',
            );
            navigate('/dashboard/listar-cadastros');
          }
        }
        const response = await getCustomer(e.target.value.replace(/\D/g, ''));
        const result = await response.json();

        if (result && result.data && result.data.id) {
          setCustomer(result.data);
          setValue('nome', result.data.name);
        }
      }
    } else {
      if (e.target.value.replace(/[^a-zA-Z0-9]/g, '').length == 14) {
        if (
          searchParams.get('fornecedor_id') &&
          !decryptData(searchParams.get('fornecedor_id')) &&
          !fornecedor
        ) {
          try {
            const datasul = await obterFornecedorPorCnpj(
              e.target.value.replace(/[^a-zA-Z0-9]/g, ''),
            );

            if (datasul) {
              snackbar.showSnackbar(
                'Já existe uma solicitação em aberto para o CNPJ informado. Favor aguardar a análise.',
              );
              navigate('/dashboard/listar-cadastros');
            }
          } catch (error) {}

          const verifyExistDB = await verificarFornecedor(
            e.target.value.replace(/[^a-zA-Z0-9]/g, ''),
          );

          if (
            verifyExistDB &&
            verifyExistDB.data &&
            verifyExistDB.data.message == 'sucesso'
          ) {
            snackbar.showSnackbar(
              'Já existe uma solicitação em aberto para o CNPJ informado. Favor aguardar a análise.',
            );
            navigate('/dashboard/listar-cadastros');
          }
        }
        const response = await getCompany(
          e.target.value.replace(/[^a-zA-Z0-9]/g, ''),
        );
        const result = await response.json();

        if (result && result.data && result.data.id) {
          setCompany(result.data);
          setValue('razao_social', result.data.business_name);
        }
      }
    }
  };

  const onSubmit = (data) => {
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }

      data.id = fornecedor_id;
    }

    data.tipo = radioValue;
    data.contratacao_teto = contratacaoTeto;

    if (radioValue == 'PF') {
      data.cpf = data.cpf.replace(/\D/g, '');
      if (customer) {
        data.customer = 1;
        data.endereco = customer.street;
        data.cep = customer.zipcode;
        data.numero = customer.number;
        data.email = customer.email;
        data.telefone = customer.phone;
        data.uf = customer.city && customer.city.state;
        data.cidade = customer.city && customer.city.name;
      }
      data.data_nasc = Moment(data.data_nasc).format('YYYY-MM-DD');
    } else {
      data.cnpj = data.cnpj.replace(/[^a-zA-Z0-9]/g, '');

      if (!contratacaoTeto) {
        setMessage('Selecione o tipo de contratação');
        setType('Error');
        setShow(true);
        return;
      }

      if (data.inscricao_municipal == '' || data.inscricao_municipal == null) {
        data.inscricao_municipal = null;
      } else {
        data.inscricao_municipal = data.inscricao_municipal.replace(/\D/g, '');
      }

      if (company) {
        data.company = 1;
        data.endereco = company.street;
        data.cep = company.zipcode;
        data.numero = company.number;
        data.email = company.email;
        data.telefone = company.phone;
        data.uf = company.city && company.city.state;
        data.cidade = company.city && company.city.name;
        data.inscricao_municipal = data.inscricao_municipal.replace(/\D/g, '');
      }
    }

    if (
      data.tipo_fornecimento == 'Prod/Ser' ||
      data.tipo_fornecimento == 'Servicos'
    ) {
      data.tipo_servico = `${selectedTipoServico.cdn_serv_inss.trim()} - ${selectedTipoServico.des_serv_inss.trim()}`;
      data.natureza_rendimento = `${selectedNaturezaRendimento[
        'cod-natur-rendto'
      ].trim()} - ${selectedNaturezaRendimento['des-natur-rendto'].trim()}`;
    }

    data.nome_usuario = user.nome_usuario;

    cadastrarFornecedor(data);
  };

  const cnpjMask = (v) => {
    v = v.replace(/[^a-zA-Z0-9]/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto dígitos
    v = v.replace(/\.(\d{3})(\d)/, '.$1/$2'); //Coloca uma barra entre o oitavo e o nono dígitos
    v = v.replace(/(\d{4})(\d)/, '$1-$2'); //Coloca um hífen depois do bloco de quatro dígitos
    return v;
  };

  const cpfMask = (v) => {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  };

  const cadastrarFornecedor = async (data) => {
    try {
      const result = await cadastroStep1(data);
      if (result && result.data && result.data.data) {
        searchParams.set('fornecedor_id', encryptData(result.data.data.id));
        setSearchParams(searchParams);
        setFornecedor(result.data.data);

        if (isRascunho) {
          if (isUsuarioSebrae) {
            navigate('/dashboard/listar-cadastros');
          } else {
            if (result.data.data.cnpj == null) {
              navigate(
                `/dashboard/listar-cadastros?fornecedor=${result.data.data.cnpj}`,
                { replace: true },
              );
            } else {
              navigate(
                `/dashboard/listar-cadastros?fornecedor=${result.data.data.cpf}`,
                { replace: true },
              );
            }
          }
          snackbar.showSnackbar('Rascunho salvo com sucesso.');
        } else {
          setActiveStep(activeStep + 1);
        }
      }
    } catch (error) {
      console.log(error);
      setMessage(error.response.data.message);
      setType('Error');
      setShow(true);
    }
  };

  const preencherFormulario = async (id) => {
    setLoading(true);
    try {
      const result = await showCadastroFornecedor(id);

      if (result && result.data && result.data.data) {
        setFornecedor(result.data.data);

        setRadioValue(result.data.data.tipo);
        setContratacaoTeto(result.data.data.contratacao_teto ?? null);
        if (result.data.data.tipo == 'PF') {
          setValue('nome', result.data.data.nome);
          setValue('cpf', cpfMask(result.data.data.documento));
          setValue('rg', result.data.data.rg);
          setValue('orgao_emissor', result.data.data.orgao_emissor);
          setValue('data_nasc', result.data.data.data_nasc);
        } else {
          setValue('razao_social', result.data.data.nome);
          setValue('cnpj', cnpjMask(result.data.data.documento));
          setValue('inscricao_estadual', result.data.data.inscricao_estadual);
          setValue('inscricao_municipal', result.data.data.inscricao_municipal);
          setValue(
            'declaracao_enquadramento',
            result.data.data.declaracao_enquadramento,
          );
          setValue('objeto_social', result.data.data.objeto_social);
        }

        if (
          result.data.data.tipo_fornecimento == 'Prod/Ser' ||
          result.data.data.tipo_fornecimento == 'Servicos'
        ) {
          setHideFields(false);
        } else {
          setHideFields(true);
        }

        if (result.data.data.tipo_servico) {
          var tipoServ = result.data.data.tipo_servico.split('-');
          if (tipoServ.length > 0) {
            setValue('tipo_servico', {
              cdn_serv_inss: tipoServ[0].trim(),
              des_serv_inss: tipoServ[1].trim(),
            });
            setSelectedTipoServico({
              cdn_serv_inss: tipoServ[0].trim(),
              des_serv_inss: tipoServ[1].trim(),
            });
          }
        }
        setValue('tipo_fornecimento', result.data.data.tipo_fornecimento);
        if (result.data.data.natureza_rendimento) {
          var natRend = result.data.data.natureza_rendimento.split('-');
          if (natRend.length > 0) {
            setValue('natureza_rendimento', {
              'cod-natur-rendto': natRend[0],
              'des-natur-rendto': natRend[1],
            });
            setSelectedNaturezaRendimento({
              'cod-natur-rendto': natRend[0],
              'des-natur-rendto': natRend[1],
            });
          }
        }
      }
      setLoading(false);
    } catch (error) {
      navigate('/dashboard/listar-cadastros');
    }
  };

  const onErrors = () => {};

  const handleClose = () => {
    setShow(false);
  };

  const handleButtonOk = () => {
    setShow(false);
  };

  const changeTipo = (value) => {
    if (value == 'PJ') {
      setValue('nome', '');
      setValue('cpf', '');
      setValue('rg', '');
      setValue('orgao_emissor', '');
    } else {
      setValue('razao_social', '');
      setValue('cnpj', '');
      setValue('inscricao_estadual', '');
      setValue('inscricao_municipal', '');
    }
    setRadioValue(value);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
      <CustomizedDialogs
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={type == 'Error' ? () => setShow(false) : handleButtonOk}
        handleClose={handleClose}
        visible={show}
      />
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress style={{ marginTop: 60 }} />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <RadioGroup
            row
            value={radioValue}
            style={{ width: '100%' }}
            aria-labelledby="demo-row-radio-buttons-group-label"
            onChange={(e) => {
              changeTipo(e.target.value);
            }}
          >
            <Grid container spacing={2} margin={0}>
              <Grid container sm={12} item>
                <p style={{ fontSize: 20, width: '100%', margin: 0 }}>
                  <b>Cadastrar</b>
                </p>
                <p style={{ fontSize: 16, width: '100%' }}>
                  Por favor, informe seus dados cadastrais
                </p>
              </Grid>

              <Grid item sm={12}>
                <strong style={{ fontSize: 11 }}>
                  * Escolha esta opção caso o pagamento do serviço seja por RPA
                  (Recibo por pagamento autônomo).
                </strong>
              </Grid>
              {!fornecedor ||
              (fornecedor && fornecedor.status === 'RASCUNHO') ||
              fornecedor.tipo === 'PF' ? (
                <Grid container sm={6} item>
                  <FormControlLabel
                    style={{
                      width: '100%',
                      border:
                        radioValue == 'PF'
                          ? '1px solid rgb(0, 102, 158)'
                          : '1px solid #bbb',
                      background: radioValue == 'PF' ? '#E7F0FF' : '#fff',
                    }}
                    checked={radioValue === 'PF'}
                    value="PF"
                    control={<Radio />}
                    label="Pessoa Física"
                  />
                </Grid>
              ) : null}

              {!fornecedor ||
              (fornecedor && fornecedor.status === 'RASCUNHO') ||
              fornecedor.tipo === 'PJ' ? (
                <Grid container sm={6} item>
                  <FormControlLabel
                    style={{
                      width: '100%',
                      border:
                        radioValue == 'PJ'
                          ? '1px solid rgb(0, 102, 158)'
                          : '1px solid #bbb',
                      background: radioValue == 'PJ' ? '#E7F0FF' : '#fff',
                    }}
                    checked={radioValue === 'PJ'}
                    value="PJ"
                    control={<Radio />}
                    label="Pessoa Jurídica"
                  />
                </Grid>
              ) : null}
            </Grid>
          </RadioGroup>
          {radioValue == 'PJ' ? (
            <Grid container spacing={2} padding={2}>
              <Grid container sm={12} item>
                <p style={{ fontSize: 16 }}>
                  <b>Dados Empresariais</b>
                </p>
              </Grid>

              <Grid container sm={6} item>
                <label style={{ color: '#707070' }}>CNPJ:</label>
                <Controller
                  name="cnpj"
                  control={control}
                  mask="**.***.***/****-**"
                  rules={{
                    required: 'campo é obrigatório',
                    validate: (value) => {
                      let v = value.replace(/[^a-zA-Z0-9]/g, '');
                      return v.length === 14;
                    },
                  }}
                  render={({
                    field: { onChange, onBlur, ref, value },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      style={{ marginTop: '5px' }}
                      mask="**.***.***/****-**"
                      maskChar={'_'}
                      value={value}
                      onBlur={onBlur}
                      disabled={fornecedor && fornecedor.status !== 'RASCUNHO'}
                      onChange={(event) => {
                        onChange(event);
                        onChangeDocument(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          margin="normal"
                          error={error}
                          disabled={
                            fornecedor && fornecedor.status !== 'RASCUNHO'
                          }
                          helperText={error && error.message}
                          fullWidth
                          {...inputProps}
                          id="cnpj"
                          placeholder="Digite o CNPJ"
                        />
                      )}
                    </InputMask>
                  )}
                />
                {errors.cnpj && errors.cnpj.type === 'validate' && (
                  <small style={{ color: 'red' }}>CNPJ Inválido</small>
                )}
              </Grid>
              <Grid container sm={6} item>
                <label style={{ color: '#707070' }}>Razão Social:</label>
                <Controller
                  name="razao_social"
                  control={control}
                  rules={{
                    required: 'Campo é obrigatório',
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      error={error}
                      helperText={error && error.message}
                      onChange={onChange}
                      fullWidth
                      placeholder="Digite a razão social da empresa"
                    />
                  )}
                />
              </Grid>
              <Grid container sm={4} item>
                <label style={{ color: '#707070' }}>
                  Inscrição Estadual:
                  <small>
                    *Caso sua empresa não possua inscrição estadual, deixar o
                    campo em branco
                  </small>
                </label>
                <Controller
                  name="inscricao_estadual"
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      style={{ marginTop: '5px' }}
                      mask="99999999999999"
                      maskChar={''}
                      value={value}
                      onBlur={onBlur}
                      onChange={(event) => {
                        onChange(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          margin="normal"
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          {...inputProps}
                          id="inscricao_estadual"
                          placeholder="Digite a Inscrição Estadual"
                        />
                      )}
                    </InputMask>
                  )}
                />
              </Grid>
              <Grid container sm={4} item>
                <label style={{ color: '#707070', marginTop: 15 }}>
                  Inscrição Municipal:
                </label>
                <Controller
                  name="inscricao_municipal"
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      style={{ marginTop: '5px' }}
                      mask="999.999.999/9999"
                      maskChar={''}
                      value={value}
                      onBlur={onBlur}
                      onChange={(event) => {
                        onChange(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          margin="normal"
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          {...inputProps}
                          id="inscricao_municipal"
                          placeholder="Digite a Inscrição Municipal"
                        />
                      )}
                    </InputMask>
                  )}
                />
              </Grid>
              <Grid container sm={4} style={{ paddingTop: 0 }} item>
                <label style={{ color: '#707070', marginTop: 25 }}>
                  Declaração de Enquadramento
                </label>
                <Controller
                  name="declaracao_enquadramento"
                  id="declaracao_enquadramento"
                  rules={{
                    required: 'Declaração de Enquadramento é obrigatório',
                    validate: (value) => {
                      return value !== 0;
                    },
                  }}
                  defaultValue={0}
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <Select
                      value={value}
                      style={{ height: 38, marginTop: 0 }}
                      error={error}
                      onChange={(e) => {
                        onChange(e);
                      }}
                      fullWidth
                    >
                      <MenuItem disabled value={0}>
                        Selecione a Declaração de Enquadramento
                      </MenuItem>
                      <MenuItem value={'Microempresa'}>
                        Microempresa (ME)
                      </MenuItem>
                      <MenuItem value={'Empresa de Pequeno Porte'}>
                        Empresa de Pequeno Porte (EPP)
                      </MenuItem>
                      <MenuItem value={'Entidades Sem fins lucrativos'}>
                        Entidades Sem fins lucrativos
                      </MenuItem>
                      <MenuItem value={'MEI'}>MEI</MenuItem>
                      <MenuItem value={'outras'}>
                        Outras categorias de Pessoas Jurídicas
                      </MenuItem>
                    </Select>
                  )}
                />

                {errors.declaracao_enquadramento &&
                  errors.declaracao_enquadramento.message && (
                    <small style={{ color: 'red' }}>
                      {errors.declaracao_enquadramento.message}
                    </small>
                  )}
              </Grid>

              <Grid item sm={12}>
                <RadioGroup
                  row
                  value={contratacaoTeto}
                  style={{ width: '100%' }}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) => {
                    setContratacaoTeto(e.target.value);
                  }}
                >
                  <Grid container spacing={1} margin={0}>
                    <Grid container sm={12} item spacing={1}>
                      <p
                        style={{
                          fontSize: 16,
                          width: '100%',
                          margin: 0,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4,
                        }}
                      >
                        Valor da contratação:
                        <Tooltip
                          title={`Caso a contratação não possua valor definido, selecione a
                    opção "Até R$ 104.000,00"`}
                          placement="top"
                        >
                          <HelpIcon />
                        </Tooltip>
                      </p>
                    </Grid>

                    <Grid container sm={12} item>
                      <FormControlLabel
                        style={{
                          width: '100%',
                          border:
                            contratacaoTeto == 'abaixo'
                              ? '1px solid rgb(0, 102, 158)'
                              : '1px solid #bbb',
                          background:
                            contratacaoTeto == 'abaixo' ? '#E7F0FF' : '#fff',
                        }}
                        checked={contratacaoTeto === 'abaixo'}
                        value="abaixo"
                        control={<Radio />}
                        label="Até R$ 104.000,00"
                      />
                    </Grid>
                    <Grid container sm={12} item>
                      <FormControlLabel
                        style={{
                          width: '100%',
                          border:
                            contratacaoTeto == 'acima'
                              ? '1px solid rgb(0, 102, 158)'
                              : '1px solid #bbb',
                          background:
                            contratacaoTeto == 'acima' ? '#E7F0FF' : '#fff',
                        }}
                        checked={contratacaoTeto === 'acima'}
                        value="acima"
                        control={<Radio />}
                        label="Acima de R$ 104.000,00"
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>

              <Grid item sm={12} style={{ paddingTop: 10 }}>
                <label style={{ color: '#707070' }}>Objeto Social</label>
                <Controller
                  name="objeto_social"
                  control={control}
                  rules={{ required: 'Objeto social é obrigatório' }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      error={error}
                      helperText={error && error.message}
                      onChange={onChange}
                      multiline
                      rows={4}
                      fullWidth
                      placeholder="Escreva aqui"
                    />
                  )}
                />
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2} padding={2}>
              <Grid container sm={12} item>
                <p style={{ fontSize: 16 }}>
                  <b>Dados Pessoais</b>
                </p>
              </Grid>
              <Grid container sm={6} item>
                <label style={{ color: '#707070' }}>CPF:</label>
                <Controller
                  name="cpf"
                  control={control}
                  mask="999.999.999-99"
                  rules={{
                    required: 'campo é obrigatório',
                    validate: (value) => {
                      let v = value.replace(/[^a-zA-Z0-9]/g, '');
                      return v.length === 11;
                    },
                  }}
                  render={({
                    field: { onChange, onBlur, ref, value },
                    fieldState: { error },
                  }) => (
                    <InputMask
                      disabled={fornecedor && fornecedor.status !== 'RASCUNHO'}
                      style={{ marginTop: '5px' }}
                      mask="999.999.999-99"
                      maskChar={'_'}
                      value={value}
                      onBlur={onBlur}
                      onChange={(event) => {
                        onChange(event);
                        onChangeDocument(event);
                      }}
                    >
                      {(inputProps) => (
                        <TextField
                          disabled={
                            fornecedor && fornecedor.status !== 'RASCUNHO'
                          }
                          margin="normal"
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          {...inputProps}
                          id="cpf"
                          placeholder="Digite o CPF"
                        />
                      )}
                    </InputMask>
                  )}
                />
                {errors.cpf && errors.cpf.type === 'validate' && (
                  <small style={{ color: 'red' }}>CPF Inválido</small>
                )}
              </Grid>
              <Grid container sm={6} item>
                <label style={{ color: '#707070' }}>Nome:</label>
                <Controller
                  name="nome"
                  control={control}
                  rules={{
                    required: 'Campo é obrigatório',
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      error={error}
                      helperText={error && error.message}
                      onChange={onChange}
                      fullWidth
                      placeholder="Digite o nome"
                    />
                  )}
                />
              </Grid>
              <Grid container sm={6} item>
                <label style={{ color: '#707070' }}>Data de Nascimento:</label>
                <Controller
                  name="data_nasc"
                  defaultValue={''}
                  rules={{
                    required: 'Campo é obrigatório',
                    validate: (value) => {
                      return value !== null || value !== undefined;
                    },
                  }}
                  control={control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <Box style={{ paddingTop: 0, width: '100%' }}>
                        <MobileDatePicker
                          inputFormat="DD/MM/YYYY"
                          value={value}
                          maxDate={new Date()}
                          onChange={(event) => {
                            onChange(event);
                            // notaFiscal.data_emissao_nf =
                            //     Moment(event).format("YYYY-MM-DD");
                          }}
                          renderInput={(params) => (
                            <TextField
                              error={errors['data_nasc']}
                              style={{ width: '100%' }}
                              helperText={error && error.message}
                              {...params}
                            />
                          )}
                        />
                      </Box>
                    </LocalizationProvider>
                  )}
                />
              </Grid>

              <Grid container sm={4} item>
                <label style={{ color: '#707070' }}>RG:</label>
                <Controller
                  name="rg"
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      error={error}
                      helperText={error && error.message}
                      onChange={onChange}
                      fullWidth
                      placeholder="Digite o rg"
                    />
                  )}
                />
              </Grid>
              <Grid container sm={2} item>
                <label style={{ color: '#707070' }}>Orgão Emissor:</label>
                <Controller
                  name="orgao_emissor"
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      style={{ marginTop: '5px' }}
                      margin="normal"
                      value={value}
                      error={error}
                      helperText={error && error.message}
                      onChange={onChange}
                      fullWidth
                      placeholder="Digite"
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}

          <Grid container sm={4} style={{ paddingTop: 0 }} item>
            <label style={{ color: '#707070', marginTop: 25 }}>
              Tipo de Fornecimento
            </label>
            <Controller
              name="tipo_fornecimento"
              id="tipo_fornecimento"
              rules={{
                required: 'Tipo de fornecimnento é obrigatório',
                validate: (value) => {
                  return value !== 0;
                },
              }}
              defaultValue={0}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Select
                  value={value}
                  style={{ height: 38, marginTop: 0 }}
                  error={error}
                  onChange={(e) => {
                    onChange(e);
                    if (
                      e.target.value == 'Prod/Ser' ||
                      e.target.value == 'Servicos'
                    ) {
                      setHideFields(false);
                    } else {
                      setHideFields(true);
                    }
                  }}
                  fullWidth
                >
                  <MenuItem disabled value={0}>
                    Selecione o tipo
                  </MenuItem>
                  <MenuItem value={'Produtos'}>Produtos</MenuItem>
                  <MenuItem value={'Servicos'}>Serviços</MenuItem>
                  <MenuItem value={'Prod/Ser'}>Prod/Ser</MenuItem>
                  <MenuItem value={'PR Rural'}>PR Rural</MenuItem>
                </Select>
              )}
            />
          </Grid>
          {!hideFields ? (
            <Grid container sm={4} style={{ paddingTop: 0 }} item>
              <label style={{ color: '#707070', marginTop: 25 }}>
                Tipo de Serviço
              </label>
              <Controller
                name="tipo_servico"
                id="tipo_servico"
                rules={{
                  required: 'Tipo de Serviço é obrigatório',
                }}
                defaultValue={null}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Autocomplete
                    options={tipoServico}
                    value={selectedTipoServico}
                    getOptionLabel={(option) => `${option.des_serv_inss}`}
                    onChange={(event, newValue) => {
                      onChange(newValue);
                      setSelectedTipoServico(newValue);
                    }}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={error}
                        helperText={error && error.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          ) : null}
          {!hideFields ? (
            <Grid container sm={4} style={{ paddingTop: 0 }} item>
              <label style={{ color: '#707070', marginTop: 25 }}>
                Natureza de Rendimento
              </label>
              <Controller
                name="natureza_rendimento"
                id="natureza_rendimento"
                rules={{
                  required: 'Natureza rendimento é obrigatório',
                }}
                defaultValue={null}
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Autocomplete
                    options={naturezaRendimentoFiltrado}
                    value={selectedNaturezaRendimento}
                    getOptionLabel={(option) => `${option['des-natur-rendto']}`}
                    onChange={(event, newValue) => {
                      onChange(newValue);
                      setSelectedNaturezaRendimento(newValue);
                    }}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={error}
                        helperText={error && error.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          ) : null}
        </Grid>
      )}
      {loading ? null : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            justifyContent: 'space-between',
            marginBottom: '-50px',
          }}
        >
          <Button
            type="submit"
            color="warning"
            variant="contained"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              setIsRascunho(true);
            }}
          >
            Salvar como rascunho
            <SaveIcon />
          </Button>
          <Button
            type="submit"
            variant="contained"
            onClick={() => {
              setIsRascunho(false);
            }}
          >
            Próximo
          </Button>
        </Box>
      )}
    </form>
  );
};
